import AsoHeader from "../../../components/Aso/Header";
import AsoValidaInfoEmpresa from "../../../components/Aso/Register/AsoValidaInfoEmpresa";

const AsoRegistroValidarInfoEmpresa = () => {

    return (
        <div>
            <AsoHeader />
            <AsoValidaInfoEmpresa />
        </div>
    );
}

export default AsoRegistroValidarInfoEmpresa;